import React, { useState, useEffect } from "react";

const HeroCarousel = ({ navigate }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: "https://images.unsplash.com/photo-1556740738-b6a63e27c4df",
      title: "Découvrez nos services complets",
      description: "Articles divers de qualité et abonnements premium pour répondre à tous vos besoins."
    },
    {
      image: "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d",
      title: "Des solutions adaptées à vos besoins",
      description: "Trouvez l'article parfait ou l'abonnement idéal pour votre entreprise."
    },
    {
      image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c",
      title: "Excellence et qualité garanties",
      description: "Nos produits sont sélectionnés avec soin pour vous offrir le meilleur."
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div style={{
      position: 'relative',
      width: '100%',
      height: '12rem',
      marginBottom: '1.5rem',
      overflow: 'hidden',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
    }}>
      {/* Image de fond avec overlay */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundImage: 'url(/za.jpeg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        filter: 'brightness(0.95)',
        zIndex: 1
      }}></div>
      
      {/* Overlay coloré */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'linear-gradient(135deg, rgba(3, 15, 27, 0.85) 0%, rgba(2, 39, 65, 0.75) 100%)',
        zIndex: 2
      }}></div>
      
      {/* Contenu texte */}
      <div style={{
        position: 'relative',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        padding: '1rem',
        color: 'white',
        zIndex: 3,
        textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
      }}>
        {/* Logo/Titre principal */}
        <div style={{ marginBottom: '0.25rem' }}>
          <h2 style={{ 
            fontSize: '2rem',
            fontWeight: 700,
            marginBottom: '0.1rem', // Réduit l'espace en dessous
            letterSpacing: '1px',
            fontFamily: '"Playfair Display", serif',
            background: 'linear-gradient(to right, #ffffff, #f0f0f0)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}>
            PAPA CHIGAN
          </h2>
          {/* Ajout de "4ème édition" en petit */}
          <p style={{
            fontSize: '0.65rem',
            fontWeight: 300,
            letterSpacing: '1px',
            margin: 0,
            opacity: 0.8,
            textTransform: 'uppercase'
          }}>
            4 ème édition
          </p>
        </div>
        
        {/* Sous-titre */}
        <div style={{
          position: 'relative',
          marginBottom: '0.5rem'
        }}>
          <p style={{
            fontSize: '1rem',
            fontWeight: 300,
            letterSpacing: '0.5px',
            margin: 0,
            padding: '0 1rem',
            position: 'relative',
            display: 'inline-block'
          }}>
            <span style={{
              position: 'absolute',
              left: 0,
              top: '50%',
              width: '20px',
              height: '1px',
              background: 'rgba(255,255,255,0.5)',
              transform: 'translateX(-100%)'
            }}></span>
            
            Un papa, un héros au quotidien !
            <span style={{
              position: 'absolute',
              right: 0,
              top: '50%',
              width: '20px',
              height: '1px',
              background: 'rgba(255,255,255,0.5)',
              transform: 'translateX(100%)'
            }}></span>
          </p>
        </div>
        
        {/* Description */}
        <p style={{
          fontSize: '0.85rem',
          fontWeight: 400,
          maxWidth: '80%',
          lineHeight: '1.4',
          opacity: 0.9,
          margin: 0
        }}>
          Collection exclusive de mode
        </p>
        
        {/* Élément décoratif */}
        <div style={{
          width: '40px',
          height: '2px',
          background: 'rgba(255,255,255,0.7)',
          margin: '0.75rem 0',
          borderRadius: '2px',
          position: 'relative'
        }}>
          {/* Ajout de "2025" en petit sous la barre */}
          <span style={{
            position: 'absolute',
            bottom: '-1.2rem',
            left: '50%',
            transform: 'translateX(-50%)',
            fontSize: '0.6rem',
            fontWeight: 300,
            opacity: 0.7,
            letterSpacing: '1px'
          }}>
            2025
          </span>
        </div>
      </div>
    </div>
  );
};

export default HeroCarousel;